import React, { Fragment } from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { SPACES } from 'common/constants/sizes';
import { Flex, Padding } from './base/layout-components';
import Text from './base/Text';
import Accordion from './base/Accordion';
import Icon from './base/Icon';
import _ from 'lodash';

const LightBorderBottom = styled.div`
  border-bottom: 1px solid ${getColor('gray', 0.2)};
`;

const FiltersSideBar = ({
  filterGroups,
  additionalFilters = [],
  postFiltersSlot
}) => {
  return (
    <Padding padding='small'>
      <Flex height='100%' direction='column'>
        {filterGroups.map(({ title, defaultIsOpen, filters = _.noop }, idx) => (
          <Fragment key={idx}>
            <Flex direction='column'>{filters()}</Flex>
          </Fragment>
        ))}
        {!!additionalFilters.length && (
          <Padding t='x-small'>
            <Accordion
              CollapseIcon={({ isOpen }) => (
                <Icon
                  color='shark'
                  size='x-small'
                  name={isOpen ? 'Collapse' : 'Expand'}
                />
              )}
              titleComponent={
                <Text padding={SPACES.smaller} size='large'>
                  Additional Filters
                </Text>
              }
            >
              {additionalFilters.map(
                ({ title, defaultIsOpen, filters = _.noop }, idx) => (
                  <Fragment key={idx}>
                    {idx !== 0 && <LightBorderBottom />}
                    <Flex direction='column'>{filters()}</Flex>
                  </Fragment>
                )
              )}
            </Accordion>
          </Padding>
        )}
        {postFiltersSlot}
      </Flex>
    </Padding>
  );
};

export default FiltersSideBar;
